module.exports = __webpack_public_path__ + "img/lera-work-3.391204d9.jpg";